import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  Box,
  Alert,
  Autocomplete,
} from '@mui/material';
import { useCreateProductMutation, useGetCategoriesQuery } from '../../../store/api/productsApi';

function QuickProductDialog({ open, onClose, onSuccess }) {
  const [createProduct, { isLoading: isSaving }] = useCreateProductMutation();
  const { data: categories } = useGetCategoriesQuery({});
  const [error, setError] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    categoryId: '',
    baseUnit: 'pcs',
    costPrice: '',
    isActive: true,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!formData.name.trim()) {
      setError('Product name is required');
      return;
    }

    try {
      const result = await createProduct({
        ...formData,
        name: formData.name.trim(),
        sku: `PRD-${Date.now()}`,
        costPrice: parseFloat(formData.costPrice) || 0,
        isActive: true,
      }).unwrap();
      
      onSuccess(result);
      setFormData({ name: '', categoryId: '', baseUnit: 'pcs', costPrice: '' });
      onClose();
    } catch (err) {
      setError(err?.data?.message || 'Error creating product');
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 700 }}>Quick Add Product</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent dividers>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                label="Product Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                autoFocus
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <Autocomplete
                options={categories || []}
                getOptionLabel={(option) => 
                  option.parent?.name ? `${option.parent.name} > ${option.name}` : option.name
                }
                value={categories?.find(c => c.id === formData.categoryId) || null}
                onChange={(_, newValue) => {
                  setFormData(prev => ({ ...prev, categoryId: newValue ? newValue.id : '' }));
                }}
                renderInput={(params) => <TextField {...params} label="Category" />}
              />
            </Grid>
            <Grid size={{ xs: 6 }}>
              <TextField
                fullWidth
                label="Base Unit"
                name="baseUnit"
                value={formData.baseUnit}
                onChange={handleChange}
              />
            </Grid>
            <Grid size={{ xs: 6 }}>
              <TextField
                fullWidth
                label="Cost Price"
                name="costPrice"
                type="number"
                value={formData.costPrice}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={onClose} disabled={isSaving}>Cancel</Button>
          <Button type="submit" variant="contained" disabled={isSaving}>
            {isSaving ? 'Saving...' : 'Create Product'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default QuickProductDialog;
